import { useCallback, useState } from "react";
import ImagesListViewItem from "./ListView/ImagesListViewItem";
import { AddImagesModal } from "../AddImagesModal/AddImagesModal";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

type AddImagesProps = {
  images: NewOrExistingFile[];
  onConfirmClick: (images: NewOrExistingFile[]) => void;
  disabled: boolean;
};

export const AddImages = ({
  images,
  onConfirmClick,
  disabled,
}: AddImagesProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState<NewOrExistingFile[]>([]);

  const handleListViewItemClick = useCallback(() => {
    setModalImages(images);
    setIsModalOpen(true);
  }, [images]);

  const handleAddImagesModalConfirmClick = useCallback(() => {
    onConfirmClick(modalImages);
  }, [modalImages, onConfirmClick]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <ImagesListViewItem
        images={images}
        onClick={handleListViewItemClick}
        disabled={disabled}
      />
      <AddImagesModal
        isOpen={isModalOpen}
        images={modalImages}
        onImagesChange={setModalImages}
        onClose={handleCloseModal}
        onConfirmClick={handleAddImagesModalConfirmClick}
      />
    </>
  );
};
